module.exports = __webpack_public_path__ + "img/decode-admin.5c9197f5.png";